

/* ===========================
 السايد منيو تفتح الاقسام ديفولت بدل المنيو

=========================== */
/* ===========================
   فتح الأقسام افتراضيًا
   ونقل تبويب الأقسام إلى اليمين
=========================== */

document.addEventListener("DOMContentLoaded", () => {
  const tab = document.querySelector(
    'hdt-tab[aria-controls="tab-mobile"]'
  );

  if (!tab) return;

  const buttons = tab.querySelectorAll("button");

  if (buttons.length > 1) {
    const menuButton = buttons[0];
    const categoriesButton = buttons[1];

    /* نقل الأقسام قبل القائمة ليظهر على اليمين */
    tab.insertBefore(categoriesButton, menuButton);

    /* فتح الأقسام تلقائيًا */
    setTimeout(() => {
      categoriesButton.click();
    }, 100);
  }
});





/* ===========================
   Mobile Toolbar
=========================== */


/* ===========================
 تعديل زر الاقسام ب الجوال يصير يفتح السايد منيو

=========================== */








/* ===========================
 تعديل زر البحث ب الجوال يصير يفتح  صفحة بحث تطبيق رابيد

=========================== */

document.addEventListener("DOMContentLoaded", () => {
  const bottomSearch = document.querySelector(".hdt-toolbart-search a");

  if (!bottomSearch) return;

  // منع الثيم من فتح الـ Drawer
  bottomSearch.removeAttribute("aria-controls");

  bottomSearch.addEventListener("click", function (e) {
    e.preventDefault();
    e.stopPropagation();

    const input = document.querySelector("#rps-csb-input");

    if (input) {
      input.focus();
      input.click();
    }
  });
});











/* ===========================
اظهار الليبل المخصص في صفحة المنتج 

=========================== */

(function () {
  "use strict";

  function installBSSKallesFix() {
    /*
     * تحديد حاوية صورة المنتج في Kalles
     */
    window.bssFixSupportProductParent = function (
      $,
      page,
      parents,
      itemHandle
    ) {
      if (page === "products") {
        var $productMedia = $(
          '.hdt-product__media[data-handle="' + itemHandle + '"]'
        ).first();

        if (!$productMedia.length) {
          $productMedia = $(".hdt-product__media[data-handle]").first();
        }

        if ($productMedia.length) {
          return $productMedia;
        }
      }

      return parents;
    };

    /*
     * إضافة الليبل فوق صورة المنتج
     */
    window.bssFixSupportAppendHtmlLabel = function (
      $,
      BSS_PL,
      parent,
      page,
      htmlLabel
    ) {
      if (page !== "products") {
        return false;
      }

      var $parent = $(parent);
      var $mainMedia = $parent.closest(".hdt-product-media__main");

      if (!$mainMedia.length) {
        $mainMedia = $(".hdt-product-media__main").first();
      }

      if (!$mainMedia.length) {
        return false;
      }

      $mainMedia.css("position", "relative");

      /*
       * منع تكرار نفس الليبل
       */
      if (
        !$mainMedia.find(
          ".bss_pl_img, .bss_pb_img, .bss-pl-frontend, [data-bss-pl-label]"
        ).length
      ) {
        $mainMedia.append(htmlLabel);
      }

      return true;
    };

    /*
     * مساعدة التطبيق في التعرف على handle المنتج
     */
    window.bssFixSupportItemHandle = function (
      $,
      page,
      handle,
      handleProductPage,
      prodUrl,
      item,
      isCartPage
    ) {
      if (page === "products") {
        var mediaHandle = $(".hdt-product__media[data-handle]")
          .first()
          .attr("data-handle");

        if (mediaHandle) {
          handle = mediaHandle;
        } else if (handleProductPage) {
          handle = handleProductPage;
        } else {
          handle = window.location.pathname
            .split("/products/")[1]
            ?.split("?")[0]
            ?.split("/")[0];
        }
      }

      return handle;
    };
  }

  /*
   * تثبيت الإصلاح فورًا، ثم تكراره لأن التطبيق يُحمّل Async
   */
  installBSSKallesFix();

  var fixAttempts = 0;

  var fixInterval = setInterval(function () {
    installBSSKallesFix();
    fixAttempts++;

    if (fixAttempts >= 30) {
      clearInterval(fixInterval);
    }
  }, 250);

  /*
   * إعادة تشغيل التطبيق بعد تحميل سكربتاته
   */
  function restartBSSLabels() {
    if (
      window.BSS_PL &&
      Array.isArray(window.BSS_PL.configData) &&
      window.BSS_PL.configData.length
    ) {
      try {
        if (typeof window.bssInitScripts === "function") {
          window.bssInitScripts();
        }
      } catch (error) {
        console.warn("BSS Kalles restart:", error);
      }
    }
  }

  window.addEventListener("load", function () {
    setTimeout(restartBSSLabels, 500);
    setTimeout(restartBSSLabels, 1500);
    setTimeout(restartBSSLabels, 3000);
  });
})();













/* ===========================
اظهار الليبل الخاص ب 1-1 مجانا
في الاماكن اللي بظهرش فيها زي تمت المشاهدة مؤخرا
=========================== */

/*
(function () {
  "use strict";

  const OFFER_COLLECTION = "1-1-offer";
  const LABEL_CLASS = "sidalih-one-one-label";

  let offerHandles = new Set();
  let applyTimer = null;

  const CARD_SELECTOR = [
    ".hdt-card-product",
    ".hdt-product-card",
    ".card-wrapper",
    ".card",
    "[data-product-id]",
    ".product-item",
    ".product-card"
  ].join(",");

  const APP_LABEL_SELECTOR = [
    ".bss_pl_img",
    ".bss_pb_img",
    ".bss_pl_label",
    "[class*='bss_pl']",
    "[class*='bss-pl']"
  ].join(",");

  function extractHandle(url) {
    if (!url) return "";

    const match = url.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : "";
  }

  async function loadOfferProducts() {
    try {
      const response = await fetch(
        `/collections/${OFFER_COLLECTION}/products.json?limit=250`,
        {
          credentials: "same-origin"
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const data = await response.json();

      offerHandles = new Set(
        (data.products || [])
          .map(function (product) {
            return product.handle;
          })
          .filter(Boolean)
      );

      applyOfferLabels();
    } catch (error) {
      console.warn("Sidalih 1+1 labels:", error);
    }
  }

  function findCard(productLink) {
    return productLink.closest(CARD_SELECTOR);
  }

  function findImageContainer(productLink) {
    const card = findCard(productLink);

    if (!card) return null;

    return (
      card.querySelector(
        [
          ".hdt-card-product__media",
          ".hdt-product-card__media",
          ".hdt-card-product__image",
          ".hdt-product-card__image",
          ".card__media",
          ".hdt-product__media",
          ".hdt-ratio",
          ".media"
        ].join(",")
      ) || card.querySelector("img")?.parentElement
    );
  }

  function hasAppLabel(card) {
    if (!card) return false;

    const labels = card.querySelectorAll(APP_LABEL_SELECTOR);

    return Array.from(labels).some(function (label) {
      return !label.classList.contains(LABEL_CLASS);
    });
  }

  function removeManualLabels(card) {
    if (!card) return;

    card
      .querySelectorAll(`.${LABEL_CLASS}`)
      .forEach(function (label) {
        label.remove();
      });
  }

  function addLabelToLink(productLink) {
    const handle = extractHandle(productLink.href);

    if (!handle || !offerHandles.has(handle)) return;

    const card = findCard(productLink);

    if (!card) return;

        /*
     * إذا تطبيق TA أضاف الليبل الأصلي،
     * نحذف الليبل اليدوي ولا نضيف واحدًا جديدًا.
        */

    /*    
    if (hasAppLabel(card)) {
      removeManualLabels(card);
      return;
    }

    const imageContainer = findImageContainer(productLink);

    if (!imageContainer) return;

    /*
     * منع إضافة الليبل اليدوي أكثر من مرة
     */

    /*
    if (
      card.querySelector(`.${LABEL_CLASS}`) ||
      imageContainer.querySelector(`.${LABEL_CLASS}`)
    ) {
      return;
    }

    imageContainer.style.position = "relative";

    const label = document.createElement("span");
    label.className = LABEL_CLASS;
    label.textContent = "1 + 1 مجانًا";

    imageContainer.appendChild(label);
  }

  function removeDuplicatesAfterAppLoads() {
    document
      .querySelectorAll(`.${LABEL_CLASS}`)
      .forEach(function (manualLabel) {
        const card = manualLabel.closest(CARD_SELECTOR);

        if (!card) return;

        if (hasAppLabel(card)) {
          manualLabel.remove();
        }
      });
  }

  function applyOfferLabels() {
    document
      .querySelectorAll('a[href*="/products/"]')
      .forEach(addLabelToLink);

    /*
     * التطبيق قد يضيف ليبله بعد الكود اليدوي،
     * لذلك نفحص مرة ثانية ونزيل التكرار.
     */

    /*
    removeDuplicatesAfterAppLoads();
  }

  function scheduleApply() {
    clearTimeout(applyTimer);

    applyTimer = setTimeout(function () {
      applyOfferLabels();
    }, 400);
  }

  function startObserver() {
    const observer = new MutationObserver(function (mutations) {
      const hasNewElements = mutations.some(function (mutation) {
        return Array.from(mutation.addedNodes).some(function (node) {
          return node.nodeType === 1;
        });
      });

      if (hasNewElements) {
        scheduleApply();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function init() {
    loadOfferProducts();
    startObserver();

    /*
     * إعادة الفحص لأن بعض الأقسام والتطبيق
     * يتم تحميلها بعد فتح الصفحة.
     */

   /* 
    setTimeout(applyOfferLabels, 1000);
    setTimeout(applyOfferLabels, 2500);
    setTimeout(applyOfferLabels, 5000);
    setTimeout(applyOfferLabels, 8000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

*/









/* ===========================
 
ترجمة المراجعات عند الانفنيت سكرولينج
=========================== */


document.addEventListener('DOMContentLoaded', function() {

    function updateBadges() {
        const badges = document.querySelectorAll('.jdgm-prev-badge');

        badges.forEach(badge => {
            const textElement = badge.querySelector('.jdgm-prev-badge__text');
            if (textElement) {
                textElement.style.visibility = 'hidden';
            }

            const stars = badge.querySelector('.jdgm-prev-badge__stars');
            if (stars) {
                stars.style.visibility = 'visible';
            }
        });

        setTimeout(function() {

            badges.forEach(badge => {

                const numberOfReviews = parseInt(badge.getAttribute('data-number-of-reviews'), 10) || 0;

                const isArabic =
                    document.documentElement.lang.toLowerCase().startsWith('ar') ||
                    document.documentElement.dir === 'rtl';

                let newText = '';

                if (isArabic) {

                    let reviewWord = (numberOfReviews === 0 || numberOfReviews === 1  || numberOfReviews > 10)
                        ? 'مراجعة'
                        : 'مراجعات';

                    newText = `(${numberOfReviews}) ${reviewWord}`;

                } else {

                    let reviewWord = numberOfReviews === 1
                        ? 'Review'
                        : 'Reviews';

                    newText = `(${numberOfReviews}) ${reviewWord}`;
                }

                const existingNewTextElement = badge.querySelector('.new-jdgm-prev-badge__text');

                if (existingNewTextElement) {
                    existingNewTextElement.textContent = newText;
                    return;
                }

                const textElement = badge.querySelector('.jdgm-prev-badge__text');
                if (textElement) {
                    textElement.remove();
                }

                const newTextElement = document.createElement('span');
                newTextElement.className = 'new-jdgm-prev-badge__text';
                newTextElement.textContent = newText;

                badge.appendChild(newTextElement);
                badge.style.visibility = 'visible';
                newTextElement.style.visibility = 'visible';

            });

        }, 700);
    }

    // تشغيل أول مرة
    updateBadges();

    // تشغيل عند تحميل منتجات جديدة (Infinite Scroll)
    const observer = new MutationObserver(() => {
        updateBadges();
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

});
















/* ===========================
 
 اظهار شعار الريال ل المنتج اللي اله
  فارينت لمن يصير عليه تغيير ع الفارينت   
  
=========================== */



document.addEventListener('DOMContentLoaded', function () {
  const symbolTemplate = document.getElementById(
    'sidalih-riyal-symbol-template'
  );

  if (!symbolTemplate) return;

  let updateTimer;

  function restoreRiyalSymbols(scope = document) {
    const moneyElements = scope.querySelectorAll('.hdt-money');

    moneyElements.forEach(function (moneyElement) {
      // لا تضف الشعار إذا كان موجودًا أصلًا
      if (moneyElement.querySelector('.sr-icon')) return;

      // لا تضفه داخل عنصر فارغ
      if (!moneyElement.textContent.trim()) return;

      const symbolClone = symbolTemplate.content.cloneNode(true);
      moneyElement.appendChild(symbolClone);
    });
  }

  // تشغيل عند تحميل الصفحة
  restoreRiyalSymbols();

  function scheduleSymbolUpdate() {
    clearTimeout(updateTimer);

    updateTimer = setTimeout(function () {
      restoreRiyalSymbols();
    }, 50);
  }

  // مراقبة تغيّر السعر عند اختيار الفارينت
  const observer = new MutationObserver(function (mutations) {
    let priceWasUpdated = false;

    mutations.forEach(function (mutation) {
      const targetElement =
        mutation.target.nodeType === Node.ELEMENT_NODE
          ? mutation.target
          : mutation.target.parentElement;

      if (
        targetElement &&
        (
          targetElement.matches?.('.hdt-money, hdt-price, hdt-compare-at-price') ||
          targetElement.closest?.(
            '.hdt-money, hdt-price, hdt-compare-at-price'
          )
        )
      ) {
        priceWasUpdated = true;
      }

      mutation.addedNodes.forEach(function (node) {
        if (
          node.nodeType === Node.ELEMENT_NODE &&
          (
            node.matches?.('.hdt-money, hdt-price, hdt-compare-at-price') ||
            node.querySelector?.('.hdt-money')
          )
        ) {
          priceWasUpdated = true;
        }
      });
    });

    if (priceWasUpdated) {
      scheduleSymbolUpdate();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });

  // دعم إضافي عند تغيير خيارات الفارينت
  document.addEventListener('change', function (event) {
    if (
      event.target.matches(
        'input[name^="options"], select[name^="options"], input[name="id"], select[name="id"]'
      )
    ) {
      scheduleSymbolUpdate();
    }
  });
});